import { ToFixedPipe } from './pipes/to-fixed.pipe';
import { GeothermalResultsComponent } from './modules/geothermal/geothermal-results.component';
import { GeothermalRangesModalComponent } from './modules/geothermal/geothermal-ranges-modal/geothermal-ranges-modal.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatSliderModule } from "@angular/material/slider";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgSelectModule } from '@ng-select/ng-select';
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { DataTablesModule } from "angular-datatables";
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxSpinnerModule } from "ngx-spinner";
import { HomeComponent } from "./pages/home/Home.component";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthConfigModule } from "./auth/Auth-config.module";
import { FiltroformComponent } from './modules/CasingWear/components/filtroform/Filtroform.component';
import { CasingwearComponent } from './modules/CasingWear/pages/Casingwear.component';
import { FilterCRComponent } from './modules/CorrosionRate/components/filter-cr/filter-cr.component';
import { FiltersCRComponent } from "./modules/CorrosionRate/components/filters-cr/filters-cr.component";
import { CorrosionRateComponent } from "./modules/CorrosionRate/pages/corrosion-rate.component";
import { PerforatedPipeComponent } from './modules/slotted-perforated-pipe/perforated-pipe/perforated-pipe.component';
import { DataCheckModalComponent } from "./modules/slotted-perforated-pipe/shared/data-check-modal/data-check-modal.component";
import { DcpFilterComponent } from "./modules/slotted-perforated-pipe/shared/slotted-modal/components/dcp-filter/dcp-filter.component";
import { MainFiltersComponent } from './modules/slotted-perforated-pipe/shared/slotted-modal/components/dcp-filter/main-filters/main-filters.component';
import { SubFiltersComponent } from "./modules/slotted-perforated-pipe/shared/slotted-modal/components/dcp-filter/sub-filters/sub-filters.component";
import { DcpTableComponent } from './modules/slotted-perforated-pipe/shared/slotted-modal/components/dcp-table/dcp-table.component';
import { SlottedModalComponent } from "./modules/slotted-perforated-pipe/shared/slotted-modal/slotted-modal.component";
import { SlottedAttachmentsComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-attachments/slotted-attachments.component';
import { SlottedLengthComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-lengths/slotted-lengths.component';
import { SlottedNotesComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-notes/slotted-notes.component';
import { SlottedPipePipesComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-pipes/slotted-pipes.component';
import { SlottedResultsComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-results/slotted-results.component';
import { SlottedSlotSchemeComponent as SlottedSlotsSchemeComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-slots-scheme/slotted-slots-scheme.component';
import { SlottedTypeComponent } from './modules/slotted-perforated-pipe/slotted-pipe/components/slotted-type/slotted-type.component';
import { SlottedPipeComponent } from "./modules/slotted-perforated-pipe/slotted-pipe/slotted-pipe.component";
import { AppmgrComponent } from "./pages/appmgr/Appmgr.component";
import { AdvancedpipeComponent } from "./modules/advancedpipe/components/advancedpipe/advancedpipe.component";
import { AdvancedpipeRangesModalComponent } from "./modules/advancedpipe/components/advancedpipe-ranges-modal/advancedpipe-ranges-modal.component";
import { CorrosionclasComponent } from "./pages/home/corrosionclas/Corrosionclas.component";
import { HelpComponent } from "./pages/home/help/help.component";
import { TestComponent } from "./pages/home/test/Test.component";
import { LayoutComponent } from "./pages/layout/Layout.component";
import { CasingwearpdfComponent } from "./pages/reports/casingwear/Casingwearpdf.component";
import { CorrosionclaspdfComponent } from "./pages/reports/corrosionclass/Corrosionclaspdf.component";
import { StatisticsComponent } from "./modules/statistics/Statistics.component";
import { UsermgrComponent } from "./pages/usermgr/Usermgr.component";
import { EmptyDataTablePipe } from "./pipes/empty-data-table/empty-data-table.pipe";
import { FilterPipe } from "./pipes/Filter.pipe";
import { RoundDecimalsPipe } from "./pipes/round-decimals/round-decimals.pipe";
import { TransformToPercentPipe } from "./pipes/transform-to-percent/transform-to-percent.pipe";
import { ContextMenuComponent } from "./shared/components/context-menu/Context-menu.component";
import { HeaderComponent } from "./shared/components/header/Header.component";
import MenuComponent from "./shared/components/menu/Menu.component";
import { SidebarComponent } from "./shared/components/sidebar/Sidebar.component";
import { TreeComponent } from "./shared/components/tree/Tree.component";
import { TreeCreateComponent } from "./shared/components/tree/Tree.create.component";
import { SaveSimulationModalComponent } from './shared/components/header-modals/save-simulation-modal/save-simulation-modal.component';
import { TreeDeleteComponent } from "./shared/components/tree/Tree.delete.component";
import { TreeLoadComponent } from "./shared/components/tree/Tree.load.component";
import { WarningMessageComponent } from './shared/components/warning-message/warning-message.component';
import { ConvertMultipleUnitsDirective } from './shared/directives/convert-multiple-units.directive';
import { ConvertUnitDirective } from './shared/directives/convert-unit.directive';
import { HighlightDirective } from "./shared/directives/Highlight.directive";
import { InterchangeableUnitDirective } from './shared/directives/interchangeable-unit.directive';
import { WarningMessageDirective } from './shared/directives/warning-message.directive';
import { AuthInterceptor } from "./shared/interceptors/AuthInterceptor";
import { PerforatedTypeComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-type/perforated-type.component";
import { PerforatedPipePipesComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-pipes/perforated-pipes.component";
import { PerforatedHolesSchemeComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-holes-scheme/perforated-holes-scheme.component";
import { PerforatedNotesComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-notes/perforated-notes.component";
import { PerforatedLengthComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-lengths/perforated-lengths.component";
import { PerforatedAttachmentsComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-attachments/perforated-attachments.component";
import { PerforatedResultsComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-results/perforated-results.component";
import { PerforatedRangesModalComponent } from "./modules/slotted-perforated-pipe/perforated-pipe/components/perforated-ranges-modal/perforated-ranges-modal.component";
import { SlottedRangesModalComponent } from "./modules/slotted-perforated-pipe/slotted-pipe/components/slotted-ranges-modal/slotted-ranges-modal.component";
import { CommaToDotDirective } from "./shared/directives/comma-to-dot.directive";
import { SafeNumberPipe } from "./pipes/safe-number/safe-number.pipe";
import { NumericInputDirective, NUMERIC_INPUT_LOCALE } from "./shared/directives/numeric-input.directive";
import { SharedModule } from './shared/shared.module';
import { CustomermgrComponent } from './modules/customermgr/customermgr.component';
import { MatSelGuidelinesComponent } from './modules/mat-sel-guidelines/mat-sel-guidelines.component';
import { Option1Component } from './modules/mat-sel-guidelines/option1/option1.component';
import { Option2Component } from './modules/mat-sel-guidelines/option2/option2.component';
import { CraComponent } from './modules/mat-sel-guidelines/cra/cra.component';
import { GeothermalComponent } from './modules/geothermal/geothermal.component';
import { ChatbotComponent } from './modules/chatbot/containers/chatbot.component';
import { DocumentsComponent } from "./modules/documents/documents.component";
import { DocumentsAddModalComponent } from './modules/documents/modals/documents-add-modal/documents-add-modal.component';
import { ThemeLabelPipe } from "./modules/statistics/pipes/theme-label.pipe";
import { CommentsModalComponent } from './modules/documents/modals/comments-modal/comments-modal.component';
import { CommentTypeBadgePipe } from "./modules/documents/pipes/comment-type-badge.pipe";
import { CommentTypePipe } from "./modules/documents/pipes/comment-type.pipe";
import { UserCommentsModalComponent } from "./shared/components/user-comments-modal/user-comments-modal.component";
import { ShareConversationModalComponent } from "./shared/components/share-conversation-modal/share-conversation-modal.component";
import { HeaderModalLayoutComponent } from './shared/components/header-modals/header-modal-layout/header-modal-layout.component';
import { HeaderModalHeaderComponent } from './shared/components/header-modals/header-modal-layout/header-modal-header/header-modal-header.component';
import { HeaderModalFooterComponent } from './shared/components/header-modals/header-modal-layout/header-modal-footer/header-modal-footer.component';
import { LoadSimulationModalComponent } from './shared/components/header-modals/load-simulation-modal/load-simulation-modal.component';
import { LoadSimulationFilterComponent } from './shared/components/header-modals/load-simulation-modal/load-simulation-filters/load-simulation-filter.component';
import { LoadSimulationTableComponent } from './shared/components/header-modals/load-simulation-modal/load-simulation-table/load-simulation-table.component';
import { DeleteSimulationModalComponent } from './shared/components/header-modals/delete-simulation-modal/delete-simulation-modal.component';
import { DeleteSimulationFilterComponent } from './shared/components/header-modals/delete-simulation-modal/delete-simulation-filters/delete-simulation-filter.component';
import { DeleteSimulationTableComponent } from './shared/components/header-modals/delete-simulation-modal/delete-simulation-table/delete-simulation-table.component';

@NgModule({
  declarations: [
    ToFixedPipe,
    AppComponent,
    HeaderComponent,
    MenuComponent,
    HomeComponent,
    ContextMenuComponent,
    // AdvancedpipeComponent migrado a AdvancedpipeModule
    CorrosionclasComponent,
    CorrosionclaspdfComponent,
    CasingwearpdfComponent,
    CorrosionRateComponent,
    FiltersCRComponent,
    FilterCRComponent,
    AppmgrComponent,
    StatisticsComponent,
    UsermgrComponent,
    SidebarComponent,
    TreeComponent,
    TreeCreateComponent,
    TreeLoadComponent,
    TreeDeleteComponent,
    HighlightDirective,
    FilterPipe,
    TestComponent,
    LayoutComponent,
    CasingwearComponent,
    FiltroformComponent,
    HelpComponent,
    InterchangeableUnitDirective,
    ConvertUnitDirective,
    ConvertMultipleUnitsDirective,
    SlottedPipeComponent,
    SlottedSlotsSchemeComponent,
    SlottedPipePipesComponent,
    SlottedTypeComponent,
    SlottedModalComponent,
    DcpTableComponent,
    DcpFilterComponent,
    MainFiltersComponent,
    SubFiltersComponent,
    SlottedLengthComponent,
    SlottedNotesComponent,
    SlottedAttachmentsComponent,
    WarningMessageDirective,
    WarningMessageComponent,
    SlottedResultsComponent,
    RoundDecimalsPipe,
    EmptyDataTablePipe,
    TransformToPercentPipe,
    DataCheckModalComponent,
    PerforatedPipeComponent,
    PerforatedTypeComponent,
    PerforatedPipePipesComponent,
    PerforatedHolesSchemeComponent,
    PerforatedNotesComponent,
    PerforatedLengthComponent,
    PerforatedAttachmentsComponent,
    PerforatedResultsComponent,
    PerforatedRangesModalComponent,
    SlottedRangesModalComponent,
    CommaToDotDirective,
    SafeNumberPipe,
    NumericInputDirective,
    CustomermgrComponent,
    MatSelGuidelinesComponent,
    Option1Component,
    Option2Component,
    CraComponent,
    GeothermalComponent,
    AdvancedpipeComponent,
    AdvancedpipeRangesModalComponent,
    ChatbotComponent,
    DocumentsComponent,
    DocumentsAddModalComponent,
    ThemeLabelPipe,
    CommentsModalComponent,
    CommentTypeBadgePipe,
    CommentTypePipe,
    UserCommentsModalComponent,
    ShareConversationModalComponent,
    GeothermalRangesModalComponent,
    GeothermalResultsComponent,
    SaveSimulationModalComponent,
    LoadSimulationModalComponent,
    LoadSimulationFilterComponent,
    LoadSimulationTableComponent,
    DeleteSimulationModalComponent,
    DeleteSimulationFilterComponent,
    DeleteSimulationTableComponent,
    HeaderModalLayoutComponent,
    HeaderModalHeaderComponent,
    HeaderModalFooterComponent
  ],
  imports: [
    BrowserModule,
    DataTablesModule,
    AppRoutingModule,
    ReactiveFormsModule,
    HttpClientModule,
    SweetAlert2Module.forRoot(),
    AuthConfigModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    NgSelectModule,
    NgxDropzoneModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSliderModule,
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: NUMERIC_INPUT_LOCALE, useValue: "en" },
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
